import { RequestGalleryEntriesByStructure } from "../dtos/gallery";
import Server from "./index";

export default class GalleryServer extends Server {
  constructor() {
    super("/gallery.php");
  }

  public get(params: RequestGalleryEntriesByStructure): Promise<any> {
    return super.get(params);
  }
}
